import React, { useEffect, useRef, useState } from 'react';
import StateDetails from '../StateDetails/StateDetails';
import InlineInfo from '../InlineInfo/InlineInfo';
import Tooltip, { MAP_TOOLTIP_ID, getStateTooltipHtml } from '../Tooltip/Tooltip';
import './Map.scss';
import Papa from 'papaparse';

const MAP_VIEWBOX_OFFSET_X = 150;
const MAP_VIEWBOX_WIDTH = 2300;
const MOBILE_MEDIA_QUERY = '(max-width: 767px)';

const getStateCenterX = (polygonPoints) => {
  const coordinates = polygonPoints.split(',').map(Number);
  const xCoordinates = coordinates.filter((_, index) => index % 2 === 0);

  return (Math.min(...xCoordinates) + Math.max(...xCoordinates)) / 2;
};

const states = [
  {
    name: 'Alabama',
    abbreviation: 'AL',
    polygonPoints: '1117.8142711810253,903.5185185185185,1162.5268420282664,877.7037037037036,1207.2394128755075,903.5185185185185,1207.2394128755075,955.148148148148,1162.5268420282664,980.9629629629629,1117.8142711810253,955.148148148148,1117.8142711810253,903.5185185185185',
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
    polygonPoints: '491.8382793196511,438.8518518518518,536.5508501668921,413.037037037037,581.2634210141332,438.8518518518518,581.2634210141332,490.48148148148147,536.5508501668921,516.2962962962963,491.8382793196511,490.48148148148147,491.8382793196511,438.8518518518518',
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
    polygonPoints: '760.1137044030972,903.5185185185185,804.8262752503382,877.7037037037036,849.5388460975792,903.5185185185185,849.5388460975792,955.148148148148,804.8262752503382,980.9629629629629,760.1137044030972,955.148148148148,760.1137044030972,903.5185185185185',
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
    polygonPoints: '983.6765586393021,826.074074074074,1028.3891294865432,800.2592592592591,1073.1017003337843,826.074074074074,1073.1017003337843,877.7037037037036,1028.3891294865432,903.5185185185185,983.6765586393021,877.7037037037036,983.6765586393021,826.074074074074',
  },
  {
    name: 'California',
    abbreviation: 'CA',
    polygonPoints: '625.975991861374,826.074074074074,670.6885627086151,800.2592592592591,715.4011335558562,826.074074074074,715.4011335558562,877.7037037037036,670.6885627086151,903.5185185185185,625.975991861374,877.7037037037036,625.975991861374,826.074074074074',
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
    polygonPoints: '760.1137044030972,748.6296296296296,804.8262752503382,722.8148148148147,849.5388460975792,748.6296296296296,849.5388460975792,800.2592592592591,804.8262752503382,826.074074074074,760.1137044030972,800.2592592592591,760.1137044030972,748.6296296296296',
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
    polygonPoints: '1430.8022671117124,671.1851851851852,1475.5148379589534,645.3703703703703,1520.2274088061945,671.1851851851852,1520.2274088061945,722.8148148148148,1475.5148379589534,748.6296296296297,1430.8022671117124,722.8148148148148,1430.8022671117124,671.1851851851852',
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
    polygonPoints: '1386.0896962644713,748.6296296296296,1430.8022671117124,722.8148148148147,1475.5148379589534,748.6296296296296,1475.5148379589534,800.2592592592591,1430.8022671117124,826.074074074074,1386.0896962644713,800.2592592592591,1386.0896962644713,748.6296296296296',
  },
  {
    name: 'District of Columbia',
    abbreviation: 'DC',
    polygonPoints: '1341.3771254172302,826.074074074074,1386.0896962644713,800.2592592592591,1430.8022671117124,826.074074074074,1430.8022671117124,877.7037037037036,1386.0896962644713,903.5185185185185,1341.3771254172302,877.7037037037036,1341.3771254172302,826.074074074074',
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
    polygonPoints: '1162.5268420282662,980.9629629629629,1207.2394128755072,955.148148148148,1251.9519837227483,980.9629629629629,1251.9519837227483,1032.5925925925926,1207.2394128755072,1058.4074074074074,1162.5268420282662,1032.5925925925926,1162.5268420282662,980.9629629629629',
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
    polygonPoints: '1207.2394128755072,903.5185185185185,1251.9519837227483,877.7037037037036,1296.6645545699894,903.5185185185185,1296.6645545699894,955.148148148148,1251.9519837227483,980.9629629629629,1207.2394128755072,955.148148148148,1207.2394128755072,903.5185185185185',
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
    polygonPoints: '447.1257084724101,980.9629629629629,491.8382793196511,955.148148148148,536.5508501668921,980.9629629629629,536.5508501668921,1032.5925925925926,491.8382793196511,1058.4074074074074,447.1257084724101,1032.5925925925926,447.1257084724101,980.9629629629629',
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
    polygonPoints: '625.975991861374,671.1851851851852,670.6885627086151,645.3703703703703,715.4011335558562,671.1851851851852,715.4011335558562,722.8148148148148,670.6885627086151,748.6296296296297,625.975991861374,722.8148148148148,625.975991861374,671.1851851851852',
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
    polygonPoints: '983.6765586393021,671.1851851851852,1028.3891294865432,645.3703703703703,1073.1017003337843,671.1851851851852,1073.1017003337843,722.8148148148148,1028.3891294865432,748.6296296296297,983.6765586393021,722.8148148148148,983.6765586393021,671.1851851851852',
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
    polygonPoints: '1073.1017003337843,671.1851851851852,1117.8142711810253,645.3703703703703,1162.5268420282664,671.1851851851852,1162.5268420282664,722.8148148148148,1117.8142711810253,748.6296296296297,1073.1017003337843,722.8148148148148,1073.1017003337843,671.1851851851852',
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
    polygonPoints: '894.2514169448202,671.1851851851852,938.9639877920613,645.3703703703703,983.6765586393024,671.1851851851852,983.6765586393024,722.8148148148148,938.9639877920613,748.6296296296297,894.2514169448202,722.8148148148148,894.2514169448202,671.1851851851852',
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
    polygonPoints: '894.2514169448202,826.074074074074,938.9639877920613,800.2592592592591,983.6765586393024,826.074074074074,983.6765586393024,877.7037037037036,938.9639877920613,903.5185185185185,894.2514169448202,877.7037037037036,894.2514169448202,826.074074074074',
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
    polygonPoints: '1028.3891294865432,748.6296296296296,1073.1017003337843,722.8148148148147,1117.8142711810253,748.6296296296296,1117.8142711810253,800.2592592592591,1073.1017003337843,826.074074074074,1028.3891294865432,800.2592592592591,1028.3891294865432,748.6296296296296',
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
    polygonPoints: '938.9639877920613,903.5185185185185,983.6765586393022,877.7037037037036,1028.3891294865432,903.5185185185185,1028.3891294865432,955.148148148148,983.6765586393022,980.9629629629629,938.9639877920613,955.148148148148,938.9639877920613,903.5185185185185',
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
    polygonPoints: '1475.5148379589534,438.8518518518518,1520.2274088061945,413.037037037037,1564.9399796534356,438.8518518518518,1564.9399796534356,490.48148148148147,1520.2274088061945,516.2962962962963,1475.5148379589534,490.48148148148147,1475.5148379589534,438.8518518518518',
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
    polygonPoints: '1296.6645545699891,748.6296296296296,1341.3771254172302,722.8148148148147,1386.0896962644713,748.6296296296296,1386.0896962644713,800.2592592592591,1341.3771254172302,826.074074074074,1296.6645545699891,800.2592592592591,1296.6645545699891,748.6296296296296',
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
    polygonPoints: '1386.0896962644713,593.7407407407408,1430.8022671117124,567.9259259259259,1475.5148379589534,593.7407407407408,1475.5148379589534,645.3703703703703,1430.8022671117124,671.1851851851852,1386.0896962644713,645.3703703703703,1386.0896962644713,593.7407407407408',
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
    polygonPoints: '1117.8142711810253,593.7407407407408,1162.5268420282664,567.9259259259259,1207.2394128755075,593.7407407407408,1207.2394128755075,645.3703703703703,1162.5268420282664,671.1851851851852,1117.8142711810253,645.3703703703703,1117.8142711810253,593.7407407407408',
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
    polygonPoints: '849.5388460975792,593.7407407407408,894.2514169448202,567.9259259259259,938.9639877920613,593.7407407407408,938.9639877920613,645.3703703703703,894.2514169448202,671.1851851851852,849.5388460975792,645.3703703703703,849.5388460975792,593.7407407407408',
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
    polygonPoints: '1028.3891294865432,903.5185185185185,1073.1017003337843,877.7037037037036,1117.8142711810253,903.5185185185185,1117.8142711810253,955.148148148148,1073.1017003337843,980.9629629629629,1028.3891294865432,955.148148148148,1028.3891294865432,903.5185185185185',
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
    polygonPoints: '938.9639877920613,748.6296296296296,983.6765586393022,722.8148148148147,1028.3891294865432,748.6296296296296,1028.3891294865432,800.2592592592591,983.6765586393022,826.074074074074,938.9639877920613,800.2592592592591,938.9639877920613,748.6296296296296',
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
    polygonPoints: '670.6885627086151,593.7407407407408,715.4011335558562,567.9259259259259,760.1137044030972,593.7407407407408,760.1137044030972,645.3703703703703,715.4011335558562,671.1851851851852,670.6885627086151,645.3703703703703,670.6885627086151,593.7407407407408',
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
    polygonPoints: '849.5388460975792,748.6296296296296,894.2514169448202,722.8148148148147,938.9639877920613,748.6296296296296,938.9639877920613,800.2592592592591,894.2514169448202,826.074074074074,849.5388460975792,800.2592592592591,849.5388460975792,748.6296296296296',
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
    polygonPoints: '670.6885627086151,748.6296296296296,715.4011335558562,722.8148148148147,760.1137044030972,748.6296296296296,760.1137044030972,800.2592592592591,715.4011335558562,826.074074074074,670.6885627086151,800.2592592592591,670.6885627086151,748.6296296296296',
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
    polygonPoints: '1430.8022671117124,516.2962962962963,1475.5148379589534,490.48148148148147,1520.2274088061945,516.2962962962963,1520.2274088061945,567.9259259259259,1475.5148379589534,593.7407407407408,1430.8022671117124,567.9259259259259,1430.8022671117124,516.2962962962963',
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
    polygonPoints: '1341.3771254172302,671.1851851851852,1386.0896962644713,645.3703703703703,1430.8022671117124,671.1851851851852,1430.8022671117124,722.8148148148148,1386.0896962644713,748.6296296296297,1341.3771254172302,722.8148148148148,1341.3771254172302,671.1851851851852',
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
    polygonPoints: '804.8262752503381,826.074074074074,849.5388460975792,800.2592592592591,894.2514169448202,826.074074074074,894.2514169448202,877.7037037037036,849.5388460975792,903.5185185185185,804.8262752503381,877.7037037037036,804.8262752503381,826.074074074074',
  },
  {
    name: 'New York',
    abbreviation: 'NY',
    polygonPoints: '1296.6645545699891,593.7407407407408,1341.3771254172302,567.9259259259259,1386.0896962644713,593.7407407407408,1386.0896962644713,645.3703703703703,1341.3771254172302,671.1851851851852,1296.6645545699891,645.3703703703703,1296.6645545699891,593.7407407407408',
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
    polygonPoints: '1162.5268420282662,826.074074074074,1207.2394128755072,800.2592592592591,1251.9519837227483,826.074074074074,1251.9519837227483,877.7037037037036,1207.2394128755072,903.5185185185185,1162.5268420282662,877.7037037037036,1162.5268420282662,826.074074074074',
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
    polygonPoints: '760.1137044030972,593.7407407407408,804.8262752503382,567.9259259259259,849.5388460975792,593.7407407407408,849.5388460975792,645.3703703703703,804.8262752503382,671.1851851851852,760.1137044030972,645.3703703703703,760.1137044030972,593.7407407407408',
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
    polygonPoints: '1162.5268420282662,671.1851851851852,1207.2394128755072,645.3703703703703,1251.9519837227483,671.1851851851852,1251.9519837227483,722.8148148148148,1207.2394128755072,748.6296296296297,1162.5268420282662,722.8148148148148,1162.5268420282662,671.1851851851852',
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
    polygonPoints: '849.5388460975792,903.5185185185185,894.2514169448202,877.7037037037036,938.9639877920613,903.5185185185185,938.9639877920613,955.148148148148,894.2514169448202,980.9629629629629,849.5388460975792,955.148148148148,849.5388460975792,903.5185185185185',
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
    polygonPoints: '581.2634210141332,748.6296296296296,625.9759918613742,722.8148148148147,670.6885627086151,748.6296296296296,670.6885627086151,800.2592592592591,625.9759918613742,826.074074074074,581.2634210141332,800.2592592592591,581.2634210141332,748.6296296296296',
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
    polygonPoints: '1251.9519837227483,671.1851851851852,1296.6645545699894,645.3703703703703,1341.3771254172304,671.1851851851852,1341.3771254172304,722.8148148148148,1296.6645545699894,748.6296296296297,1251.9519837227483,722.8148148148148,1251.9519837227483,671.1851851851852',
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
    polygonPoints: '1475.5148379589534,593.7407407407408,1520.2274088061945,567.9259259259259,1564.9399796534356,593.7407407407408,1564.9399796534356,645.3703703703703,1520.2274088061945,671.1851851851852,1475.5148379589534,645.3703703703703,1475.5148379589534,593.7407407407408',
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
    polygonPoints: '1251.9519837227483,826.074074074074,1296.6645545699894,800.2592592592591,1341.3771254172304,826.074074074074,1341.3771254172304,877.7037037037036,1296.6645545699894,903.5185185185185,1251.9519837227483,877.7037037037036,1251.9519837227483,826.074074074074',
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
    polygonPoints: '804.8262752503381,671.1851851851852,849.5388460975792,645.3703703703703,894.2514169448202,671.1851851851852,894.2514169448202,722.8148148148148,849.5388460975792,748.6296296296297,804.8262752503381,722.8148148148148,804.8262752503381,671.1851851851852',
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
    polygonPoints: '1073.1017003337843,826.074074074074,1117.8142711810253,800.2592592592591,1162.5268420282664,826.074074074074,1162.5268420282664,877.7037037037036,1117.8142711810253,903.5185185185185,1073.1017003337843,877.7037037037036,1073.1017003337843,826.074074074074',
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
    polygonPoints: '894.2514169448202,980.9629629629629,938.9639877920613,955.148148148148,983.6765586393024,980.9629629629629,983.6765586393024,1032.5925925925926,938.9639877920613,1058.4074074074074,894.2514169448202,1032.5925925925926,894.2514169448202,980.9629629629629',
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
    polygonPoints: '715.4011335558562,826.074074074074,760.1137044030972,800.2592592592591,804.8262752503383,826.074074074074,804.8262752503383,877.7037037037036,760.1137044030972,903.5185185185185,715.4011335558562,877.7037037037036,715.4011335558562,826.074074074074',
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
    polygonPoints: '1341.3771254172302,516.2962962962963,1386.0896962644713,490.48148148148147,1430.8022671117124,516.2962962962963,1430.8022671117124,567.9259259259259,1386.0896962644713,593.7407407407408,1341.3771254172302,567.9259259259259,1341.3771254172302,516.2962962962963',
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
    polygonPoints: '1207.2394128755072,748.6296296296296,1251.9519837227483,722.8148148148147,1296.6645545699894,748.6296296296296,1296.6645545699894,800.2592592592591,1251.9519837227483,826.074074074074,1207.2394128755072,800.2592592592591,1207.2394128755072,748.6296296296296',
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
    polygonPoints: '581.2634210141332,593.7407407407408,625.9759918613742,567.9259259259259,670.6885627086151,593.7407407407408,670.6885627086151,645.3703703703703,625.9759918613742,671.1851851851852,581.2634210141332,645.3703703703703,581.2634210141332,593.7407407407408',
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
    polygonPoints: '1117.8142711810253,748.6296296296296,1162.5268420282664,722.8148148148147,1207.2394128755075,748.6296296296296,1207.2394128755075,800.2592592592591,1162.5268420282664,826.074074074074,1117.8142711810253,800.2592592592591,1117.8142711810253,748.6296296296296',
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
    polygonPoints: '938.9639877920613,593.7407407407408,983.6765586393022,567.9259259259259,1028.3891294865432,593.7407407407408,1028.3891294865432,645.3703703703703,983.6765586393022,671.1851851851852,938.9639877920613,645.3703703703703,938.9639877920613,593.7407407407408',
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
    polygonPoints: '715.4011335558562,671.1851851851852,760.1137044030972,645.3703703703703,804.8262752503383,671.1851851851852,804.8262752503383,722.8148148148148,760.1137044030972,748.6296296296297,715.4011335558562,722.8148148148148,715.4011335558562,671.1851851851852',
  },
];

const Map = () => {
  const [stateData, setStateData] = useState([]);
  const [selectedState, setSelectedState] = useState('al');
  const [selectedStateData, setSelectedStateData] = useState(null);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.matchMedia(MOBILE_MEDIA_QUERY).matches
  );
  const stateDetailsRef = useRef(null);
  const mapScrollerRef = useRef(null);
  const hasUserSelectedStateRef = useRef(false);
  const hasAutoCenteredMapRef = useRef(false);
  const selectedStateIndex = stateData.findIndex(
    (state) => state.abbreviation.toLowerCase() === selectedState
  );
  const hasStates = stateData.length > 0;
  const previousState = hasStates
    ? stateData[(selectedStateIndex - 1 + stateData.length) % stateData.length]
    : null;
  const nextState = hasStates
    ? stateData[(selectedStateIndex + 1) % stateData.length]
    : null;

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MEDIA_QUERY);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  useEffect(() => {
    fetch('./assets/data.csv')
      .then(response => response.text())
      .then(csv => {
        Papa.parse(csv, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            // Merge the state data with the CSV results
            let mergedStateData = [];
            for(let i=0; i<states.length; i++) {
              mergedStateData.push({
              ...states[i], 
              ...(results.data.find((itmInner) => itmInner.state_abbreviation === states[i].abbreviation))}
              );
            }
            setStateData(mergedStateData);
          }
        });
      })
      .catch(error => {
        console.error('Error fetching or parsing CSV:', error);
        setError('<span><cfa-icon>Error</cfa-icon><br><strong>We’re sorry, but something went wrong on our end while loading the map.</strong><br> Please try again, or let us know if the problem continues.');
      });
  }, []);

  useEffect(() => {
    if (selectedState) {
      setSelectedStateData(
        stateData.find(state => state.abbreviation.toLowerCase() === selectedState)
      );
      // Move the selected state element to the end of the SVG
      const svg = document.querySelector('svg.map');
      const selectedElement = svg?.querySelector('.selected');
      if (selectedElement) {
        svg.appendChild(selectedElement);
      }
    } else {
      setSelectedStateData(null);
    }
  }, [selectedState, stateData]);

  useEffect(() => {
    if (hasUserSelectedStateRef.current && selectedStateData && stateDetailsRef.current) {
      stateDetailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [selectedStateData]);

  useEffect(() => {
    if (stateData.length === 0 || typeof window === 'undefined') {
      return;
    }

    const centerMapOnMobile = () => {
      const mapScroller = mapScrollerRef.current;

      if (!mapScroller) {
        return;
      }

      if (!window.matchMedia(MOBILE_MEDIA_QUERY).matches) {
        hasAutoCenteredMapRef.current = false;
        mapScroller.scrollLeft = 0;
        return;
      }

      if (hasUserSelectedStateRef.current || hasAutoCenteredMapRef.current) {
        return;
      }

      mapScroller.scrollLeft = Math.max((mapScroller.scrollWidth - mapScroller.clientWidth) / 2, 0);
      hasAutoCenteredMapRef.current = true;
    };

    const frameId = window.requestAnimationFrame(() => {
      centerMapOnMobile();
      window.requestAnimationFrame(centerMapOnMobile);
    });

    const handleResize = () => {
      hasAutoCenteredMapRef.current = false;
      centerMapOnMobile();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.removeEventListener('resize', handleResize);
    };
  }, [stateData.length]);

  useEffect(() => {
    const mapScroller = mapScrollerRef.current;

    if (
      !mapScroller ||
      !selectedStateData ||
      !hasUserSelectedStateRef.current ||
      typeof window === 'undefined' ||
      !window.matchMedia(MOBILE_MEDIA_QUERY).matches
    ) {
      return;
    }

    const selectedStateCenterX = getStateCenterX(selectedStateData.polygonPoints);
    const selectedStateOffset = ((selectedStateCenterX + MAP_VIEWBOX_OFFSET_X) / MAP_VIEWBOX_WIDTH) * mapScroller.scrollWidth;
    const targetScrollLeft = selectedStateOffset - (mapScroller.clientWidth / 2);
    const maxScrollLeft = Math.max(mapScroller.scrollWidth - mapScroller.clientWidth, 0);

    mapScroller.scrollTo({
      left: Math.min(Math.max(targetScrollLeft, 0), maxScrollLeft),
      behavior: 'smooth',
    });
  }, [selectedStateData]);

  const selectState = (abbreviation) => {
    hasUserSelectedStateRef.current = true;
    setSelectedState(abbreviation);
  };

  const handleStateClick = (e) => {
    selectState(e.currentTarget.dataset.abbreviation);
  };

  const handleStateSelectChange = (e) => {
    selectState(e.target.value);
  };

  const handleStateKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      selectState(e.currentTarget.dataset.abbreviation);
    }
  };

  const handlePreviousState = () => {
    if (hasStates && previousState) {
      selectState(previousState.abbreviation.toLowerCase());
    }
  };

  const handleNextState = () => {
    if (hasStates && nextState) {
      selectState(nextState.abbreviation.toLowerCase());
    }
  };

  return (
    <>
      {error && (
        <div className="container-fluid wrapper">
          <div className="row">
            <div className="col-xs-12 text-center">
              <p className="large" dangerouslySetInnerHTML={{ __html: error }}></p>
            </div>
          </div>
        </div>
      )}
      {!error && (
        <div className="container-fluid wrapper">
          <div className="row middle-md center-md">
            <div className="col-xs-12 text-center">
              <h2 className="eyebrow"><span>Explore by state</span></h2>
            </div>
          </div>
        </div>
      )}
      {!error && (
        <div className="map-container">
          <div className="map-scroll-shell">
            <div
              className="map-scroll-viewport"
              ref={mapScrollerRef}
              tabIndex={0}
              aria-label="United States map. On small screens, drag horizontally to explore states."
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1200"
                height="800"
                viewBox="-150 350 2300 780"
                preserveAspectRatio="xMidYMid slice"
                className="map"
              >
                {stateData.map((state) => (
                  <g
                    key={state.name}
                    className={`map__state` + (selectedState === state.abbreviation.toLowerCase() ? ' selected' : '')}
                    data-abbreviation={ state.abbreviation.toLowerCase() }
                    tabIndex={0}
                    role="button"
                    onClick={handleStateClick}
                    onKeyDown={handleStateKeyDown}
                    data-tooltip-id={MAP_TOOLTIP_ID}
                    data-tooltip-html={getStateTooltipHtml(state)}
                    data-tooltip-place="bottom"
                  >
                    <polygon points={ state.polygonPoints } />
                    <text 
                      x={ state.polygonPoints.split(",")[2] } 
                      y={ (parseFloat(state.polygonPoints.split(",")[7]) - parseFloat(state.polygonPoints.split(",")[5])) / 2 + parseFloat(state.polygonPoints.split(",")[5]) } 
                      dominantBaseline="middle" 
                      textAnchor="middle"
                      className="map__state-abbreviation"
                    >
                      { state.abbreviation }
                    </text>
                  </g>
                ))}
              </svg>
            </div>
            <div className="map-scroll-hint" aria-hidden="true">
              <span><cfa-icon>swipe</cfa-icon> Swipe sideways to explore the map</span>
            </div>
          </div>
          {!isMobile && <Tooltip />}
          <div className="navbar">
            <div className="container-fluid wrapper">
              <div className="row">
                <div className="col-xs-12">
                  <div className="navbar__state-select">
                      <button
                        type="button"
                        className="navbar__state-button"
                        onClick={handlePreviousState}
                        disabled={!hasStates}
                        aria-label={previousState ? `Select previous state: ${previousState.name}` : 'Select previous state'}
                      >
                        <cfa-icon aria-hidden="true">arrow_back</cfa-icon>
                        <span>Previous state</span>
                      </button>
                      <div>
                        <label htmlFor="state-select" className="strong navbar__state-select-label">
                          Select a state:
                        </label>
                        <select
                          id="state-select"
                          className="cfa-select"
                          value={selectedState || ''}
                          onChange={handleStateSelectChange}
                        >
                          <option value="">— Select a state —</option>
                          {stateData.map(state => (
                            <option key={state.abbreviation} value={state.abbreviation.toLowerCase()}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    <button
                      type="button"
                      className="navbar__state-button"
                      onClick={handleNextState}
                        disabled={!hasStates}
                        aria-label={nextState ? `Select next state: ${nextState.name}` : 'Select next state'}
                    >
                        <span>Next state</span>
                      <cfa-icon aria-hidden="true">arrow_forward</cfa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {selectedStateData ? (
            <div ref={stateDetailsRef}>
              <StateDetails stateData={selectedStateData} />
            </div>
          ) : (
            <div className="container-fluid wrapper">
              <div className="row">
                <div className="col-xs-12 text-center">
                  <div className="spacer" style={{ '--height': 1 }}></div>
                  <p className="large"><em>Select a state to see details</em></p>
                  <div className="spacer" style={{ '--height': 1 }}></div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Map;
